import { SetterOrUpdater, useRecoilState } from 'recoil'

import { isDisabledState } from './state'

export type TUseFieldJumper = {
  isDisabled: boolean
  setIsDisabled: SetterOrUpdater<boolean>
  disable: () => void
  enable: () => void
}

const useFieldJumper = (): TUseFieldJumper => {
  const [isDisabled, setIsDisabled] = useRecoilState(isDisabledState)

  const disable = (): void => {
    setIsDisabled(true)
  }

  const enable = (): void => {
    setIsDisabled(false)
  }

  return { isDisabled, setIsDisabled, disable, enable }
}

export default useFieldJumper
